import * as baseTheme from './base';

const component = {
  titleBgColor: baseTheme.colors.n500,

  // HowTo
  howToBgColor: baseTheme.colors.r500,
  howToTitleColor: baseTheme.colors.r500,

  // Footer
  footerBgColor: baseTheme.colors.n500,
};

const standard = {
  ...baseTheme,
  component,
};

export { standard };
